import { ACCOUNT_STATUSES } from "@chef/constants";
import { useBillingQuery } from "@chef/state-management";
import { MyAccountLayout } from "../../components/MyAccountLayout";
import { AccountActive } from "../../components/MySubscription/AccountActive";
import { AccountPaused } from "../../components/MySubscription/AccountPaused";
import { AccountPostalAreaClosed } from "../../components/MySubscription/AccountPostalAreaClosed";

export const MyAccountSubscriptionPage = () => {
  const { data: billingQuery } = useBillingQuery();
  const { status } = billingQuery?.billing || {};

  return (
    <MyAccountLayout page="subscription">
      <AccountPage accountStatus={status} />
    </MyAccountLayout>
  );
};

const AccountPage = ({
  accountStatus,
}: {
  accountStatus: number | undefined;
}) => {
  if (accountStatus === ACCOUNT_STATUSES.PAUSED) {
    return <AccountPaused />;
  }
  if (accountStatus === ACCOUNT_STATUSES.POSTAL_AREA_CLOSED) {
    return <AccountPostalAreaClosed />;
  }
  return <AccountActive />;
};
